import { setNews } from '../actions';
import { identityPayload, createReducer, forAction } from '../utils';

const initialState = [];

export default createReducer(
  [forAction(setNews, identityPayload)],
  initialState,
);
